import { createSelector } from 'reselect'

import {
  getNumProjectionYears,
  getPopulation,
  getPopulationGrowthRate,
  PROJECTION_YEAR_DELTA
} from '../selectors';

import { compoundGrowthSeries } from '../../services/statistics';

// Global Selectors
// Selectors may need to access multiple slices of state to do their job.
// Return a list of populations (numbers)
export const getProjectedPopulationSeries = createSelector(
  [getPopulation, getPopulationGrowthRate, getNumProjectionYears],
  (population, populationGrowthRate, numProjectionYears): number[] => {
    const tail = compoundGrowthSeries(population, populationGrowthRate, numProjectionYears - PROJECTION_YEAR_DELTA);
    const head = []
    for (let i = 0; i < PROJECTION_YEAR_DELTA; i++) {
      head.push(0); // base population is 0
    }

    const combined = head.concat(tail);
    return combined;
  }
)
export const getProjectedPopulation = createSelector(
  [getProjectedPopulationSeries],
  (populationSeries): number => {
    return populationSeries.slice(-1)[0]; // last item in the projection!
  }
)



// WEBPACK FOOTER //
// ./src/store/selectors/population.ts